module.exports = __webpack_public_path__ + "static/media/image.d078968b.jpg";